import React from 'react';
import ReactSelect, { GroupBase, Props } from 'react-select';
import { useDarkMode } from '../hooks';

export interface IOption {
  label: string;
  value: any;
}

type SelectProps<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
> = {
  name?: string;
  isValid?: boolean;
  clearable?: boolean;
  readonly?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: IOption[];
  placeholder?: string;
  CustomOptionCompo?: React.FunctionComponent;
  CustomNoOptionCompo?: React.FunctionComponent;
  className?: string;
} & Props<Option, IsMulti, Group>;

const Select = ({ options, ...rest }: SelectProps) => {
  const { isDarkMode } = useDarkMode();

  return (
    <ReactSelect
      {...rest}
      value={options.find((val: IOption) => val.value === rest.value)}
      components={{
        IndicatorSeparator: () => null,
      }}
      menuPlacement="auto"
      isSearchable={false}
      options={options}
      placeholder={rest.placeholder || 'Lựa chọn...'}
      // Render menu qua portal + z-index cao để dropdown luôn NỔI TRÊN nội dung (vd nút 3 chấm của bài
      // viết trước đây đè xuyên qua lớp filter). menuPosition fixed để không bị cha overflow cắt.
      menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
      menuPosition="fixed"
      className={`text-center before:text-base  rounded-lg dark:border-zinc-50/10 text-[#18191E] dark:text-slate-50 ${rest.className}`}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        placeholder: (base) => ({ ...base, textAlign: 'left' }),
        menu: (base) => ({
          ...base,
          width: 'max-content',
          minWidth: '100%',
          zIndex: 9999,
        }),
        menuList: (base) => ({
          ...base,
          // overflow: 'initial',
          paddingTop: 0,
          textAlign: 'left',
        }),
        singleValue: (base) => ({
          ...base,
          color: isDarkMode ? '#f8fafc' : '#1e293b',
          textAlign: 'left',
        }),
        control: (base) => ({
          ...base,
          backgroundColor: isDarkMode ? '#27272A' : '#ffffff  ',
          border: '1px solid #C8CCD8',
          borderRadius: '8px !important',
          boxShadow: '0 !important',
          textAlign: 'right',
          position: 'static',
          transform: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '48px',
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected
            ? isDarkMode
              ? '#ffffff'
              : '#F6F7F8'
            : isDarkMode
            ? '#F6F7F8'
            : '#ffffff',
          color: state.isSelected ? '#000000' : '#000000',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: isDarkMode ? '#ffffff' : '#F6F7F8',
          },
        }),
      }}
    />
  );
};

export default Select;
